import { Database } from "lucide-react";
import { SiGithub } from "@icons-pack/react-simple-icons";

interface TerraformStateRowProps {
  state: {
    id: number;
    backend_type: "s3" | "github";
    s3_bucket_name: string | null;
    s3_key: string | null;
    github_state_filename: string | null;
  };
  connectedTo: { label: string; href: string };
  onRemove?: () => void;
}

export function TerraformStateRow({ state, connectedTo, onRemove }: TerraformStateRowProps) {
  return (
    <div className="flex items-center justify-between py-3">
      <div className="flex items-center gap-2.5 min-w-0 flex-1">
        {state.backend_type === "s3" ? (
          <Database className="w-4 h-4 text-orange-500 dark:text-orange-400 flex-shrink-0" />
        ) : (
          <SiGithub className="w-4 h-4 text-gray-700 dark:text-gray-300 flex-shrink-0" />
        )}
        <div className="min-w-0 flex-1">
          <span className="text-sm text-gray-900 dark:text-gray-100 font-mono truncate block">
            {state.backend_type === "s3"
              ? `${state.s3_bucket_name}/${state.s3_key}`
              : state.github_state_filename}
          </span>
          <p className="text-xs text-gray-600 dark:text-gray-400 mt-0.5">
            Connected to{" "}
            <a
              href={connectedTo.href}
              className="font-medium text-primary hover:underline"
            >
              {connectedTo.label}
            </a>
          </p>
        </div>
      </div>
      {onRemove && (
        <button
          onClick={onRemove}
          className="flex-shrink-0 ml-4 inline-flex items-center px-3 py-1.5 border border-red-300 dark:border-red-600 text-xs font-medium rounded-full text-red-700 dark:text-red-300 bg-white dark:bg-zinc-900 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors cursor-pointer"
        >
          Remove
        </button>
      )}
    </div>
  );
}
